import React from 'react';
import Table from '../../components/common/Table';
import { renderBooleanBadge } from '../../utils/displayUtils';
import { FirearmSpecificDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface FirearmSpecificTableProps {
  data: FirearmSpecificDTO[];
  handleEdit: (row: FirearmSpecificDTO) => void;
  handleDelete: (row: FirearmSpecificDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const FirearmSpecificTable: React.FC<FirearmSpecificTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },
        {
          label: 'Parent (Firearms Type)',
          key: 'firearmTypeId',
          render: (row: FirearmSpecificDTO) =>
            <span>{row.firearmType?.title || 'Unknown'}</span>,
        },
        {
          label: 'Not On List',
          key: 'notOnList',
          render: (row: FirearmSpecificDTO) =>
            renderBooleanBadge(row.notOnList ?? false, 'Yes', 'No'),
        },
        {
          label: 'Barrel Length',
          key: 'barrelLength',
          render: (row: FirearmSpecificDTO) =>
            renderBooleanBadge(row.barrelLength ?? false, 'Yes', 'No'),
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: FirearmSpecificDTO) =>
            renderBooleanBadge(row.isActive ?? false, 'Yes', 'No'),
        },
        {
          label: 'Position',
          key: 'displayPosition',
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (createdUtc: Date) =>
            convertToUserTime(createdUtc?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default FirearmSpecificTable;
